/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StoreItemVolumeViewerModel } from './StoreItemVolumeViewerModel';
import {
    StoreItemVolumeViewerModelFromJSON,
    StoreItemVolumeViewerModelFromJSONTyped,
    StoreItemVolumeViewerModelToJSON,
} from './StoreItemVolumeViewerModel';
import type { ViewerBannerModel } from './ViewerBannerModel';
import {
    ViewerBannerModelFromJSON,
    ViewerBannerModelFromJSONTyped,
    ViewerBannerModelToJSON,
} from './ViewerBannerModel';

/**
 * 【viewer向け】読前・読後バナー、縦読み/横読み、組方向、コミック情報
 * @export
 * @interface ViewerSettingInfoModel
 */
export interface ViewerSettingInfoModel {
    /**
     * 縦読みか横読みか
     * * true: 横読み
     * * false: 縦読み
     * @type {boolean}
     * @memberof ViewerSettingInfoModel
     */
    isReadingHorizontal: boolean;
    /**
     * 横読みの組み方向（rtl/ltr）
     * * rtl: 右から左
     * * ltr: 右から右
     * @type {string}
     * @memberof ViewerSettingInfoModel
     */
    readingDirection: string;
    /**
     * 
     * @type {StoreItemVolumeViewerModel}
     * @memberof ViewerSettingInfoModel
     */
    dataComicInfo: StoreItemVolumeViewerModel;
    /**
     * ビューアーのバナー
     * @type {Array<ViewerBannerModel>}
     * @memberof ViewerSettingInfoModel
     */
    viewerBanner?: Array<ViewerBannerModel>;
}

/**
 * Check if a given object implements the ViewerSettingInfoModel interface.
 */
export function instanceOfViewerSettingInfoModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isReadingHorizontal" in value;
    isInstance = isInstance && "readingDirection" in value;
    isInstance = isInstance && "dataComicInfo" in value;

    return isInstance;
}

export function ViewerSettingInfoModelFromJSON(json: any): ViewerSettingInfoModel {
    return ViewerSettingInfoModelFromJSONTyped(json, false);
}

export function ViewerSettingInfoModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewerSettingInfoModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isReadingHorizontal': json['isReadingHorizontal'],
        'readingDirection': json['readingDirection'],
        'dataComicInfo': StoreItemVolumeViewerModelFromJSON(json['dataComicInfo']),
        'viewerBanner': !exists(json, 'viewerBanner') ? undefined : ((json['viewerBanner'] as Array<any>).map(ViewerBannerModelFromJSON)),
    };
}

export function ViewerSettingInfoModelToJSON(value?: ViewerSettingInfoModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isReadingHorizontal': value.isReadingHorizontal,
        'readingDirection': value.readingDirection,
        'dataComicInfo': StoreItemVolumeViewerModelToJSON(value.dataComicInfo),
        'viewerBanner': value.viewerBanner === undefined ? undefined : ((value.viewerBanner as Array<any>).map(ViewerBannerModelToJSON)),
    };
}

